import { TreeNodeWithMetadata } from './DirectoryTreeWrapper';
import { useDocumentsDragAndDrop } from '../../../hooks/useDocumentsDragAndDrop';
import { useRef } from 'react';
import { Category } from 'interfaces/documents';

export const DirectoryTreeDraggableNode =({ nodeData, onMove }: { nodeData: TreeNodeWithMetadata; onMove: (affectedFolderIds: Array<number | null | undefined>) => void }) => {
    const componentItem = {
        ...nodeData?.metadata,
        type: 'category',
        name: nodeData.title,
    };
    const { drag, drop, active } = useDocumentsDragAndDrop(componentItem as Category, {
        onMove,
    });

    const ref = useRef<HTMLElement>(null);
    if (nodeData.key) {
        drag(ref.current);
    }
    drop(ref.current);

    return (
        <span
            data-node-key={nodeData.key}
            ref={ref}
            className={active ? 'smx-drop-target' : ''}
        >
            {nodeData.title as string}
        </span>
    );
}